import React from 'react';
import { useNavigate } from 'react-router-dom';

const plans = [
  {
    id: 'free',
    name: 'Gratis',
    price: '0',
    period: '/mnd',
    desc: 'Kom i gang med grunnleggende funksjoner',
    features: ['10 bomberegninger per måned', 'Grunnleggende trafikkinfo', 'E-poststøtte', 'Én rute lagret'],
    cta: 'Start gratis',
    popular: false,
    accent: 'rgba(156,163,175,0.3)',
  },
  {
    id: 'premium',
    name: 'Premium',
    price: '499',
    period: '/mnd',
    desc: 'Komplett tilgang for privatpersoner',
    features: ['Ubegrenset bomberegninger', 'Sanntids trafikkoppdateringer', 'EV/Hybrid rabattoptimalisering', 'Prioritert kundeservice', 'Månedlige kostnadsrapporter', 'Automatisk ruteoptimalisering'],
    cta: 'Velg Premium',
    popular: true,
    accent: '#FF5722',
  },
  {
    id: 'enterprise',
    name: 'Bedrift',
    price: '1 499',
    period: '/mnd',
    desc: 'Skreddersydde løsninger for flåter',
    features: ['Alt i Premium', 'Flåtestyring opptil 50 kjøretøy', 'Dedikert kontoadministrator', 'API-tilgang', 'Tilpassede rapporter', '24/7 telefonsupport'],
    cta: 'Kontakt oss',
    popular: false,
    accent: '#004F98',
  },
];

const PricingSection = () => {
  const navigate = useNavigate();
  return (
    <section id="pricing" className="pricing-section-padding" style={{ position: 'relative', padding: '120px 48px', background: 'var(--color-background)', overflow: 'hidden' }}>
      <div style={{ position: 'absolute', top: '15%', right: '-80px', width: '350px', height: '350px', border: '1px solid rgba(0,79,152,0.07)', transform: 'rotate(20deg)', pointerEvents: 'none' }} />
      <div style={{ position: 'absolute', bottom: '10%', left: '-60px', width: '280px', height: '280px', border: '1px solid rgba(255,87,34,0.06)', transform: 'rotate(-15deg)', pointerEvents: 'none' }} />

      <div style={{ maxWidth: '1440px', margin: '0 auto', position: 'relative', zIndex: 1 }}>
        <div style={{ textAlign: 'center', marginBottom: '80px' }}>
          <div style={{ display: 'inline-block', background: 'rgba(0,79,152,0.1)', border: '1px solid rgba(0,79,152,0.2)', borderRadius: '2px', padding: '4px 12px', marginBottom: '20px' }}>
            <span style={{ fontFamily: 'var(--font-heading)', fontSize: '11px', fontWeight: 600, letterSpacing: '0.14em', textTransform: 'uppercase', color: '#004F98' }}>Priser</span>
          </div>
          <h2 style={{ fontFamily: 'var(--font-heading)', fontSize: 'clamp(28px, 4vw, 42px)', fontWeight: 700, color: 'var(--color-foreground)', lineHeight: 1.1, letterSpacing: '-0.01em', marginBottom: '16px' }}>Velg riktig plan</h2>
          <p style={{ fontFamily: 'var(--font-body)', fontSize: '16px', color: 'var(--color-muted-foreground)', maxWidth: '480px', margin: '0 auto', lineHeight: 1.6 }}>Ingen bindingstid. Oppgrader eller nedgrader når som helst.</p>
        </div>

        <div className="pricing-grid" style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '24px', alignItems: 'start' }}>
          {plans?.map((plan, i) => (
            <div
              key={plan?.id}
              className="pricing-card-offset"
              style={{
                position: 'relative',
                background: plan?.popular ? 'rgba(255,87,34,0.06)' : 'rgba(255,255,255,0.02)',
                border: `2px solid ${plan?.popular ? 'rgba(255,87,34,0.4)' : 'rgba(224,228,232,0.1)'}`,
                borderRadius: '2px',
                padding: '40px 32px',
                marginTop: i === 1 ? '-16px' : '0',
              }}
            >
              <div style={{ position: 'absolute', top: '-1px', right: '-1px', width: '24px', height: '24px', borderTop: `3px solid ${plan?.accent}`, borderRight: `3px solid ${plan?.accent}` }} />
              {plan?.popular && (
                <div style={{ position: 'absolute', top: '-14px', left: '50%', transform: 'translateX(-50%)', background: '#FF5722', border: '2px solid rgba(255,87,34,0.6)', borderRadius: '2px', padding: '4px 16px', whiteSpace: 'nowrap' }}>
                  <span style={{ fontFamily: 'var(--font-heading)', fontSize: '11px', fontWeight: 700, letterSpacing: '0.1em', textTransform: 'uppercase', color: '#FFFFFF' }}>Mest populær</span>
                </div>
              )}
              <div style={{ marginBottom: '8px' }}>
                <span style={{ fontFamily: 'var(--font-heading)', fontSize: '20px', fontWeight: 700, color: 'var(--color-foreground)', letterSpacing: '0.02em' }}>{plan?.name}</span>
              </div>
              <p style={{ fontFamily: 'var(--font-caption)', fontSize: '13px', color: 'var(--color-muted-foreground)', marginBottom: '24px', lineHeight: 1.5 }}>{plan?.desc}</p>
              <div style={{ display: 'flex', alignItems: 'baseline', gap: '4px', marginBottom: '32px' }}>
                <span style={{ fontFamily: 'var(--font-heading)', fontSize: '40px', fontWeight: 700, color: plan?.popular ? '#FF5722' : 'var(--color-foreground)', letterSpacing: '-0.02em' }}>kr {plan?.price}</span>
                <span style={{ fontFamily: 'var(--font-caption)', fontSize: '14px', color: 'var(--color-muted-foreground)' }}>{plan?.period}</span>
              </div>
              <div style={{ height: '1px', background: 'rgba(224,228,232,0.08)', marginBottom: '24px' }} />
              <ul style={{ listStyle: 'none', padding: 0, margin: '0 0 32px', display: 'flex', flexDirection: 'column', gap: '12px' }}>
                {plan?.features?.map(f => (
                  <li key={f} style={{ display: 'flex', gap: '10px', alignItems: 'flex-start' }}>
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke={plan?.accent} strokeWidth="2.5" style={{ flexShrink: 0, marginTop: '2px' }}><polyline points="20 6 9 17 4 12" /></svg>
                    <span style={{ fontFamily: 'var(--font-body)', fontSize: '14px', fontWeight: 400, color: 'var(--color-muted-foreground)', lineHeight: 1.5 }}>{f}</span>
                  </li>
                ))}
              </ul>
              <button
                onClick={() => navigate(plan?.id === 'enterprise' ? '/contact' : '/register')}
                style={{
                  width: '100%',
                  background: plan?.popular ? '#FF5722' : 'transparent',
                  border: `2px solid ${plan?.accent}`,
                  borderRadius: '2px',
                  padding: '14px 24px',
                  fontFamily: 'var(--font-heading)',
                  fontSize: '13px',
                  fontWeight: 700,
                  letterSpacing: '0.08em',
                  textTransform: 'uppercase',
                  color: plan?.popular ? '#FFFFFF' : 'var(--color-foreground)',
                  cursor: 'pointer',
                }}
              >
                {plan?.cta}
              </button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PricingSection;
